var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("요청하신 페이지를 찾을 수 없습니다.")])])
}]

export { render, staticRenderFns }